import { userStore } from '@/stores/user.store';
import { trackEvent } from '@/utils/analytics';
import { SUPPORT_EMAIL } from '@/utils/constants';
import { handleMailTo } from '@/utils/platform';

export const openChannelsBetaFeedback = (
  source: 'settings' | 'channel_dashboard'
) => {
  trackEvent('CHANNELS_BETA_FEEDBACK_CLICKED', { source });
  handleMailTo(
    SUPPORT_EMAIL,
    'Channels beta feedback',
    `Account: ${userStore.user?.email ?? 'unknown'}\n\n`
  );
};
